import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";

interface LastReportResponse {
  url: string;
}

export function useGetLastReportActividad(idActividad: number | null) {
  return useQuery<LastReportResponse | null, Error>({
    queryKey: ["lastReport", "actividad", idActividad],
    queryFn: async () => {
      if (!idActividad) return null;

      try {
        const response = await axiosInstance.get(
          `/reportes/actividad/${idActividad}/last-report`
        );
        return response.data;
      } catch (error: any) {
        // Si es 404, no hay reporte previo, retornar null en lugar de error
        if (error.response?.status === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!idActividad,
    retry: (failureCount, error: any) => {
      // No reintentar si es 404
      if (error.response?.status === 404) {
        return false;
      }
      return failureCount < 2;
    },
  });
}
